<template>
  <div :class="{timeVideo: $route.name == 'timeVideo',appContainer: true}">
    <router-view ref="routers" :params="params"></router-view>
    <div class="toTop" @click="toTop()" v-show="showToTop">
      <!-- <img src="@assets/img/common/toTop.svg" alt="top"> -->
      <div class="toTopIcon"></div>
      <img class="toTopTips" src="@assets/img/common/toTopTips.png" alt="top">
    </div>
  </div>
</template>

<script>
import routes from '@common/routes'
import common from '@common/common'
import { apis } from '@common/config'

export default {
  name: 'app',
  watch: {
    $route(to, from) {
      this.matchRoutes(to.path)
      console.log(to, from)
      if (to.path.split('/')[1] === from.path.split('/')[1]) {
        // 如果同模版组件间切换，则强行调用刷新列表接口
        if (!this.$refs.routers.$refs.content) return
        this.$refs.routers.$refs.content.searchOptions = {} // 重置搜索条件
        this.$refs.routers.$refs.content.filterOptions = {} // 重置过滤条件
        let sorts = this.$refs.routers.$refs.content.sorts;
        sorts && sorts[0] && (sorts[0].selected = true)
        sorts && sorts[1] && (sorts[1].selected = false)
        this.$refs.routers.$refs.content.datePicker = ""
        // this.$refs.routers.$refs.content.page.pageIndex = 1;
        if(this.$refs.routers.$refs.content.page) {
          this.$refs.routers.$refs.content.page.pageIndex = 1;
        }
        this.$refs.routers.$refs.content.getList('noKeyWord')
      }
    }
  },
  data() {
    return {
      params: {},
      showToTop: false
    }
  },
  methods: {
    setResult(e) {
      console.log(this.$store.state)
      if(e.content.to == 'client'){
        this.$store.commit('setNewClient', new Date())
      }
      if(this.$store.state.sentimentNotice){
        this.notifyBox(e.content.logo, e.content.title, e.content.msg, e.content.id, e.content.to, e.content.hb_id, e.content.type)
      }
    },
    matchRoutes(path) {
      path = path || this.$route.path
      const param = {}

      routes.pages.forEach((i) => {
        if (i.path === path) {
          param.title = i.title
          param.showLink = i.showLink
          param.filter = i.filter

        } else {
          i.children && i.children.forEach((c) => {
            if (i.path + c.path === path) {
              param.title = c.title
              param.showLink = c.showLink
              param.filter = c.filter
            }
          })
        }
      })
      this.params = param
    },
    toTop() {
      common.goTop()
    },
    addScroll() {
      window.addEventListener('scroll', this.handleScroll)
    },
    handleScroll() {
      const bodyheight = document.body.clientHeight
      let scrollTop = window.document.documentElement.scrollTop || window.document.body.scrollTop

      if (scrollTop > bodyheight / 3) {
        this.showToTop = true
      } else {
        this.showToTop = false
      }
    },
    getClueDetail(r) {
      const path = this.$route.path
      if (path.indexOf('internetClue') > -1) return

      const info = {
        id: r.content.id
      }
      common.myFetch(apis.clue_notifyDetail, info)
        .then((r) => {
          if (r) {
            const res = r.detail
            if (!res) return

            const data = {
              id: res.id,
              title: res.title,
              body: res.content,
              img: res.cover,
              type: res.source_type == '5' ? 'weibo' : 'others'
            }

            common.browserNotify(data)
          }
        })
    },
    handleNotify() {
      const isLogin = common.checkLogin()
      if (isLogin) {
        common.handleSocket(this.getClueDetail, 'internetcluenotice')
      }
    },
    notifyBox(logo, title, msg, id, from, hb_id, type) {
      const notice = this.$appNotificationHandler.openNotification(title, {
          body: msg,
          tag: id,
          icon: logo,
          renotify: true
      })

      //消息框显示时被调用  
      notice.onshow = function() {  
          console.log('notification is shows up');  
      };  

      //消息框被点击时被调用  
      notice.onclick = function() {  
        if(from == 'client'){
          common.jump('/client?id='+id, true)
        }else{
          common.jump(`/media?type=${type}&hb_id=${hb_id}&content_id=${id}`,true) 
        }
          console.log('notification is click');  
      };  

      //当有错误发生时会onerror函数会被调用  
      //如果没有granted授权，创建Notification对象实例时，也会执行onerror函数  
      notice.onerror = function() {  
          console.log('notification is an error');  
      };  

      //一个消息框关闭时onclose函数会被调用  
      notice.onclose = function() {  
          console.log('notification is closed');  
      };  

    }
  },
  mounted() {
    this.matchRoutes()
    this.addScroll()
    this.$appNotificationHandler.requestPermission();
    common.handleSocket(this.setResult, "sentiment")

    common.needMark('.appContainer')

    
    // console.log(this.$route)
    // this.notifyBox()
    // this.handleNotify() // 其他页面弹互联线索提示
  }
}
</script>
<style lang="less" src='./assets/css/global.less'></style>
<style lang="less">
.appContainer {
  min-width: 100%;
}
.toTop {
  position: fixed;
  right: 30px;
  bottom: 158px;
  cursor: pointer;
  z-index: 1000;

  &:hover {
    .toTopTips {
      display: block;
    }

    .toTopIcon {
      background: url('./assets/img/common/toTopOn.svg') no-repeat;
    }
  }

  .toTopIcon {
    width: 46px;
    height: 46px;
    background: url('./assets/img/common/toTop.svg') no-repeat;
    background-position: center center;
    background-size: 100% 100%;
  }

  .toTopTips {
    display: none;
    position: absolute;
    top: 56px;
    left: 50%;
    margin-left: -47px;
    width: 94px;
    height: 40px;
  }
}
</style>
